// src/lib/opportunity/orgFormTemplateClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OrgFormTemplate, OrgFormTemplateBlock } from "./orgFormTemplateTypes.js";

export function listOrgFormTemplates() {
  return opportunityFetch<{ ok: true; templates: OrgFormTemplate[] }>(
    "/api/opportunity/form-template-list",
    { method: "GET" },
  );
}

export function getOrgFormTemplate(templateId: string) {
  const q = new URLSearchParams({ template_id: templateId });
  return opportunityFetch<{
    ok: true;
    template: OrgFormTemplate;
    blocks: OrgFormTemplateBlock[];
  }>(`/api/opportunity/form-template-list?${q.toString()}`, { method: "GET" });
}

export type UpsertOrgFormTemplatePayload = {
  id?: string;
  display_name: string;
  form_key?: string;
  is_active?: boolean;
  allow_rep_contact_override?: boolean;
  include_calculations?: boolean;
  sort_order?: number;
};

export function upsertOrgFormTemplate(payload: UpsertOrgFormTemplatePayload) {
  return opportunityFetch<{ ok: true; template: OrgFormTemplate }>(
    "/api/opportunity/form-template-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteOrgFormTemplate(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/form-template-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderOrgFormTemplates(orderedIds: string[]) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/form-template-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ordered_ids: orderedIds }),
  });
}

export type UpsertOrgFormTemplateBlockPayload = {
  id?: string;
  form_template_id: string;
  block_type?: "text" | "calc";
  label?: string | null;
  helper_text?: string | null;
  default_body?: string | null;
  calc_config?: Record<string, unknown> | null;
  sort_order: number;
};

export function upsertOrgFormTemplateBlock(payload: UpsertOrgFormTemplateBlockPayload) {
  return opportunityFetch<{ ok: true; block: OrgFormTemplateBlock }>(
    "/api/opportunity/form-template-block-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteOrgFormTemplateBlock(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/form-template-block-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderOrgFormTemplateBlocks(payload: {
  form_template_id: string;
  ordered_ids: string[];
}) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/form-template-block-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
